import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const LOGO = "/brand/aviana-logo-600.png";

export default function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the sisterhood. Look for moon-cycle letters in your inbox.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    }
  };
  return (
    <footer className="bg-aviana-plum text-aviana-cream mt-32 relative overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden />
      <div className="container-aviana relative py-24 grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="inline-flex items-center justify-center w-28 h-28 rounded-full bg-aviana-cream ring-2 ring-aviana-goldSoft/60 mb-6 p-2">
            <img src={LOGO} alt="Aviana" className="w-full h-full object-contain" />
          </div>
          <p className="overline text-aviana-goldSoft mb-3">Sacred Embodied Living</p>
          <p className="max-w-md text-aviana-cream/75 leading-relaxed font-serif text-lg italic">
            A sanctuary for women returning to themselves through movement, nature,
            and equine-guided experiences. Founded by Holly Johnson.
          </p>
          <form onSubmit={submit} className="mt-10 flex gap-2 max-w-md" data-testid="newsletter-form">
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Receive moon-cycle letters"
              className="flex-1 bg-transparent border-b border-aviana-cream/30 focus:border-aviana-gold py-3 text-sm outline-none transition-colors placeholder:text-aviana-cream/40 text-aviana-cream"
              data-testid="newsletter-input"
            />
            <button type="submit" className="btn-gold !py-2.5 !px-5 !text-[11px]" data-testid="newsletter-submit">Subscribe</button>
          </form>
        </div>
        <div className="md:col-span-3">
          <p className="overline text-aviana-goldSoft mb-6">Wander</p>
          <ul className="space-y-3 text-aviana-cream/70 text-sm">
            <li><Link to="/retreats" className="hover:text-aviana-goldSoft">Retreats</Link></li>
            <li><Link to="/trainings" className="hover:text-aviana-goldSoft">Teacher Trainings</Link></li>
            <li><Link to="/courses" className="hover:text-aviana-goldSoft">Online Courses</Link></li>
            <li><Link to="/events" className="hover:text-aviana-goldSoft">Sacred Events</Link></li>
            <li><Link to="/resources" className="hover:text-aviana-goldSoft">Resources</Link></li>
            <li><Link to="/host-a-training" className="hover:text-aviana-goldSoft">Host a Training</Link></li>
            <li><Link to="/become-an-aerial-yoga-teacher-trainer" className="hover:text-aviana-goldSoft">Become a Trainer</Link></li>
            <li><Link to="/contact" className="hover:text-aviana-goldSoft">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="overline text-aviana-goldSoft mb-6">Find Aviana</p>
          <div className="flex gap-5 text-aviana-cream/80">
            <a href="https://instagram.com/aviana_yoga" aria-label="Instagram" className="hover:text-aviana-goldSoft" data-testid="social-instagram"><Instagram /></a>
            <a href="https://facebook.com/aerialyogateachertraining" aria-label="Facebook" className="hover:text-aviana-goldSoft" data-testid="social-facebook"><Facebook /></a>
            <a href="https://youtube.com/@aviana_yoga" aria-label="Youtube" className="hover:text-aviana-goldSoft" data-testid="social-youtube"><Youtube /></a>
          </div>
          <p className="mt-12 text-[11px] tracking-[0.2em] uppercase text-aviana-cream/40">© {new Date().getFullYear()} Aviana Yoga LLC</p>
          <p className="text-[11px] text-aviana-cream/40 mt-2">All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
